<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@5.8.55/css/materialdesignicons.min.css">

  <!-- <div v-touch:tap="onTapItem">Button</div>

  <div v-for="(item, i) in 10" :key="i">
	  <div v-touch:swipe="onSwipeItem(item, i)">Button</div>
  </div>

<span v-touch:tap="touchHandler">Tap Me</span>

<span v-touch="touchHandler">Tap Me</span>

<span v-touch:swipe="swipeHandler">Swipe Here</span>

<span v-touch:swipe.left="swipeHandler">Swipe Left Here</span>

<span v-touch:longtap="longtapHandler">Long Tap Event</span>

<span v-touch:press="startHandler" v-touch:release="endHandler">Press and Release Events</span>

<span v-touch:drag.once="movedHandler">Triggered once when starting to move and tapTolerance is exceeded</span>
<span v-touch:drag="movingHandler">Continuously triggered while dragging</span>

<span v-touch:hold="touchHoldHandler">Touch and hold on the screen for a while</span>

<span v-touch:tap="tapHandler" v-touch:longtap="longtapHandler" v-touch:swipe.left="swipeLeftHandler" v-touch:press="startHandler" v-touch:release="endHandler" v-touch:swipe.right="swipeRightHandler">Mix Multiple Events</span>

<span v-touch:tap="tapHandler" v-touch-options="{touchClass: 'active', swipeTolerance: 80, touchHoldTolerance: 300}">Different options</span>

<span v-touch:tap="tapHandler" v-touch-class="active">Customize touch class</span>

<span v-touch:tap="tapHandler" v-touch-options="{touchClass: 'active'}">Customize touch class</span> -->

        <!-- <panZoom>
            <img src="https://picsum.photos/300">
        </panZoom> -->
<!--
        <panZoom>
            <p>You can zoom me</p>
        </panZoom>

        <panZoom selector="#g1">
            <svg height="210" width="400">
                <g id="g1">
                    <path d="M150 0 L75 200 L225 200 Z" />
                </g>
            </svg>
        </panZoom> -->

  <div id="mask" v-if="maskVisible"
  style="background: #8080808f;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  z-index: 9;"
  @click="maskVisible = !maskVisible">
  </div>

  <div id="thumnails-content" v-if="maskVisible">
    <ul>
      <li class="thumb-box" v-for="(slideThumb, indexThumb) in lista" :key="indexThumb" @click="thumbClick(indexThumb)">
          <!-- <img :src="require(`${url}/${params.dir}/${params.lang}/thumbs/page-${indexThumb+1}.jpg`)"> -->
          <img :src="`${url}/${params.dir}/${params.lang}/thumbs/page-${indexThumb}.jpg`" alt="">
          <!-- <img :src="require(url + `/thumbs/page-${indexThumb+1}.jpg`)"> -->
      </li>
    </ul>
  </div>

	<!-- <button @click="toggler = !toggler">
		Open the lightbox.
	</button> -->

  <div style="margin: 10px auto 4px;;  width: 300px;  display: inline-flex;height: 50px;">
    <b-button type="is-info" style="margin-right:10px;width: 45px;" @click="prevPage((pageTarget-1))">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
        <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
      </svg>
    </b-button>

      <b-input placeholder="Info" min=0 :max=(sliders.length-1) type="number" v-model.lazy="pageTarget" @input="pageSelected = Number(pageTarget)" style="width: 125px;"></b-input>

    <b-button type="is-info" style="margin-left:10px;width: 45px;" @click="nextPage((pageTarget+1))">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
      </svg>
    </b-button>
    <button @click="maskVisible = !maskVisible"
    style="width: 60px;
  cursor: pointer;
  padding: 0px;
  margin: 0px 0px 0px 20px;
  background: rgb(22, 125, 240);
  border: medium;
  border-radius: 4px;
  height: 40px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16" style="margin: 2px;  color: white;">
        <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>
      </svg>
    </button>

    <a :href="`https://lib.pulsar.pl/doc/materialy_reklamowe/katalog_Pulsar_${params.lang.toUpperCase()}.pdf`" target="_new"
    style="width: 60px;
  cursor: pointer;
  padding: 0px;
  margin: 0px 0px 0px 20px;
  background: rgb(22, 125, 240);
  border: medium;
  border-radius: 4px;
  height: 40px;">
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16" style="color: white;  position: relative;  top: 5px;">
  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
  <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>
</svg>
    </a>
  </div>
  <!-- <b-field style="max-width: 200px;  margin: 0px auto 15px;  padding-top: 16px;">
    <b-numberinput type="is-info" v-model.lazy="pageTarget" @input="pageSelected = Number(pageTarget)"></b-numberinput>
  </b-field> -->


  <!-- <div id="navLeft"></div> -->
  <panZoom :options="{minZoom: 1, maxZoom: 3, autocenter: true, bounds: true, smoothScroll: true, beforeWheel: beforeWheelHandler}" @panstart="onPanStart" @init="onInit">
  <!-- <panZoom :options="{minZoom: 1, maxZoom: 5,   initialX: 300,  initialY: 500, bounds: true, smoothScroll: true, beforeWheel: beforeWheelHandler}" @panstart="onPanStart" @init="onInit"> -->
        <!-- <panZoom
          height="100%"
          width="100%"
          ref="panZoom"
          selector="#zoomable"
          id="canvasContainer"
          :options="{
          autocenter: true,
          bounds: true,
          minZoom: 1,
          maxZoom: 4,
          smoothScroll: true,
          transformOrigin: {x: 0, y: 0},
          zoomDoubleClickSpeed: 1,
          beforeWheel: beforeWheelHandler}"
          @panstart="onPanStart"
          @panzoom="onPanZoom"
          @init="onInit"
        > -->
    <carousel
      :per-page="1"
      :navigate-to="pageSelected"
      :mouseDrag="false"
      :touchDrag="false"
      :touch-drag="false"
      :centerMode="true"
      :paginationEnabled="false"
      :navigationEnabled="false"
      @pageChange="changePage"
      :ref="'panzoomRef'"
      >

      <!-- <slide v-for="(slide, index) in lista" :key="index" :data-index="index+1" :data-name="'page-'+(index+1)"> -->
          <!-- <img :src="require(`../assets/img/page-${index+1}.jpg`)"> -->
          <!-- <img :src="require(`../assets/img/page-${index+1}.jpg`)"> -->
          <!-- <img :src="`${url}/${params.dir}/${params.lang}/img/page-${index+1}.jpg`" alt="">
      </slide> -->

      <slide :data-index="pageTarget" :data-name="'page-' + (pageTarget)">
          <!-- <img :src="require(`../assets/img/page-${index+1}.jpg`)"> -->
          <!-- <img :src="require(`../assets/img/page-${index+1}.jpg`)"> -->
          <img :src="`${url}/${params.dir}/${params.lang}/img/page-${pageTarget}.jpg`" alt="">
      </slide>
    <!-- <slide
        data-index="2"
        data-name="MySlideName"
        @slideclick="handleSlideClick">
      <img src="../assets/pages_PL/page-3.jpg">
    </slide> -->
    </carousel>
  </panZoom>
  <!-- <div id="navRight"></div> -->

	<FsLightbox
		:toggler="toggler"
	  :showThumbsOnMount="true"
		:sources="[
			imgLarge
		]"
	/>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ref } from 'vue'

import FsLightbox from "fslightbox-vue";
import { Carousel, Slide } from 'vue-carousel';

export default {
	components: { FsLightbox, Carousel, Slide },
  props: ['params'],
	data() {
		return {
      lang: 'en',
      lista: 1,
			toggler: false,
      pageSelected: 0,
      pageTarget: 0,
      imgLarge: '',
      maskVisible: false,
      boolTouchDrag: true,
      size: 0,
      url: '',
      urlImage: '../assets/',
		}
	},
  computed: {
    ...mapGetters('app', ['sliders'])
  },
  watch: {
    sliders (newValue) {
      if (newValue) {
        this.changeList ()
      }
    }
  },
  methods: {
    onInit: function(panzoomInstance, id) {
      const self = this
      panzoomInstance.on('panstart', function(e) {
        // console.log('Fired when pan is just started ', e);
        // Note: e === instance.
      });

      panzoomInstance.on('pan', function(e) {
        // console.log('Fired when the `element` is being panned', e);
      });

      panzoomInstance.on('panend', function(e) {
        console.log('Fired when pan ended', e);
        console.log(self.$refs.panzoomRef.$el)
        // self.$refs.panzoomRef.$el.style.transform = "matrix(0.9, 0, 0, 0.9, 0, 0)"
      });

      panzoomInstance.on('zoom', function(e) {
        // console.log('Fired when `element` is zoomed', e);
        console.log(self.$refs.panzoomRef.$el)
      });

      panzoomInstance.on('zoomend', function(e) {
        // console.log('Fired when zoom animation ended', e);
      });

      panzoomInstance.on('transform', function(e) {
        // This event will be called along with events above.
        // console.log('Fired when any transformation has happened', e);
      });
    },
    changeList () {
      if (this.sliders.length>0) {
        this.lista = this.sliders
      }
    },
    beforeWheelHandler(e) {
      // console.log(e)
      // console.log(e.deltaY, e.wheelDeltaY)
      // console.log(screenX, screenY)
        // console.log(this.$refs.panzoomRef)
      // var shouldIgnore = !e.altKey;
      // console.log(shouldIgnore)
      // return shouldIgnore;
    },
    beforeMouseDown: function(e) {
      // console.log(e)
      // allow mouse-down panning only if altKey is down. Otherwise - ignore
      // var shouldIgnore = !e.altKey;
      // return shouldIgnore;
    },
    prevPage (e) {
      if (e < 0 ) {
        e = 0
      }
      this.changePage(e)
    },
    nextPage (e) {
      if (e > this.sliders.length-1) {
        e = this.sliders.length-1
      }
      this.changePage(e)
    },
    onPanStart (e) {
      // console.log(e)
    },
    handleSlideClick (dataset) {
      // console.log(dataset.index, dataset.name)
      // this.imgLarge = require('../assets/pages_PL/large/'+ dataset.name + '.jpg')
      // this.toggler = !this.toggler
    },
    changePage (dataset) {
      this.pageTarget = dataset
    },
    thumbClick (index) {
      this.maskVisible = false
      this.pageSelected = index
      this.pageTarget = index
      this.changePage (index)
    }
  },
  created() {
    this.url = process.env.VUE_APP_ROOT_API
  }
}
</script>

<style scoped>
.bi-caret-right-fill {
  margin:2px 4px;
}
  .VueCarousel-slide img {
  width: 100%;
  max-width: 640px;
  }
  #thumnails-content {
    width: 100%;
  height: 100%;
  position: absolute;
  }
#thumnails-content ul {
max-width: 1200px;
  margin: 0px auto;
  display: block;
  position: relative;
  z-index: 10;
  opacity: 1;
  }
  .thumb-box {
width: 70px;
  height: 100px;
  background: #eee;
  float: left;
  padding: 0px;
  margin: 4px;
  cursor: pointer;
  transition: all 0.3s;
  }
  .thumb-box:hover {
    transform: scale(1.1);
  }
  #navLeft, #navRight {
  height: 500px;
  width: 45px;
  position: absolute;
  top: 20%;
  background: #8080805c;
  }
#navLeft {
left: 0px;
}
#navRight {
right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue